var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c("DynamicDemo")],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href: "https://github.com/OXOYO/X-Highlight-Vue",
          target: "_blank"
        }
      },
      [
        _c("img", {
          staticStyle: {
            position: "absolute",
            top: "0",
            right: "0",
            border: "0"
          },
          attrs: {
            src:
              "https://s3.amazonaws.com/github/ribbons/forkme_right_orange_ff7600.png",
            alt: "Fork me on GitHub"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "app-header" }, [
      _c("img", { attrs: { src: require("./assets/logo.png") } }),
      _vm._v(" "),
      _c("h2", [_vm._v("X-Highlight-Vue")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-244f861e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-244f861e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/App.vue
// module id = null
// module chunks = 